<template>
  <div>
    <template v-if="!isEditing">
      <div
        class="c-nav__item"
        :class="[{ active: isActive }, { selected: isSelected }]"
        @mouseover="isActive = true"
        @mouseout="isActive = false"
      >
        <sc-link
          v-if="fields && fields.link"
          :field="fields.link"
          class="c-nav__link"
          aria-haspopup="true"
          aria-expanded="false"
          @click.prevent="openMenuSecondary(fields.title.value.toLowerCase().split(' ').join(''))"
        />
        <div
          ref="navDropdown"
          class="c-nav-dropdown"
          :class="fields.title.value.toLowerCase().split(' ').join('')"
          aria-label="submenu"
        >
          <div
            class="c-nav-dropdown__container"
            :class="{ 'nav-full-width': fields.fullWidth.value }"
          >
            <div class="c-nav-controls">
              <button
                type="button"
                class="c-button__back"
                @click="backMenu(fields.title.value.toLowerCase().split(' ').join(''))"
              >
                Back
              </button>
              <button
                type="button"
                class="c-button__close"
                @click="closeMenu()"
                aria-label="Mobile Back Button"
              ></button>
            </div>
            <sc-text
              v-if="fields && fields.title"
              :field="fields.title"
              class="c-nav-dropdown__nav-title"
            />
            <div class="c-nav-content">
              <sc-placeholder name="jss-dropdown" :rendering="rendering" />
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="c-nav__item">
        <sc-link v-if="fields && fields.link" :field="fields.link" class="c-nav__link" />
        <div class="c-nav-dropdown" v-if="$jss.sitecoreContext().routeName === 'Header'">
          <div class="c-nav-dropdown__container">
            <div class="c-nav-content">
              <sc-placeholder name="jss-dropdown" :rendering="rendering" />
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { Placeholder, Text, Link } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Navigation-Link',
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  },
  data: function () {
    return {
      isActive: false,
      isSelected: false
    };
  },
  components: {
    ScPlaceholder: Placeholder,
    ScText: Text,
    ScLink: Link
  },
  computed: {
    isEditing() {
      return this.$jss.sitecoreContext().pageEditing;
    }
  },
  mounted() {
    if (!this.isEditing) {
      this.handleView();
      window.addEventListener('resize', this.handleView);
    }
  },
  methods: {
    handleView() {
      this.isMobileLogo = document.body.clientWidth <= 1125;

      if (document.body.clientWidth >= 992) {
        this.isSelected = false;
        if (this.$refs.navDropdown) {
          this.$refs.navDropdown.style.width = '';
          this.$refs.navDropdown.style.right = '';
        }
      } else {
        let width = document.body.clientWidth + 'px';
        var activeDropDown = document.querySelector('.c-nav__item.selected .c-nav-dropdown');

        if (activeDropDown) {
          document.querySelector('.c-nav__item.selected .c-nav-dropdown').style.width = width;
          document.querySelector('.c-nav__item.selected .c-nav-dropdown').style.right = '-' + width;
        }
      }
    },
    openMenuSecondary(item) {
      if (document.body.clientWidth <= 991) {
        this.isSelected = true;
        let width = document.body.clientWidth + 'px';

        document.querySelector(
          '.c-site__nav-container'
        ).style.transform = `translate3d(-${width}, 0px, 0px )`;
        document.querySelector('.c-site__nav-container').style.transition = 'all 0.5s ease 0s';
        document.querySelector('.c-site__nav-container').style.overflow = 'visible';

        document.querySelector(`.${item}`).style.width = width;
        document.querySelector(`.${item}`).style.right = '-' + width;
      }
    },
    backMenu(item) {
      if (document.body.clientWidth <= 991) {
        this.isSelected = false;
        let width = document.body.clientWidth + 'px';

        document.querySelector('.c-site__nav-container').style.right = '-' + width;
        document.querySelector('.c-site__nav-container').style.width = width;
        document.querySelector('.c-site__nav-container').style.overflow = 'visible';
        document.querySelector(
          '.c-site__nav-container'
        ).style.transform = `translate3d(0, 0px, 0px )`;

        document.querySelector(`.${item}`).style.right = '-' + width;
        document.querySelector(`.${item}`).style.width = '0px';
      }
    },
    closeMenu() {
      if (document.body.clientWidth <= 991) {
        document.querySelector('.c-site__nav-container').style.width = '0px';

        document.querySelector('.c-site').style.transform = '';
        document.querySelector('.c-site').style.transition = 'all 0.5s ease 0s';
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.c-site__header {
  .c-nav__list {
    > div {
      display: block;

      @include desktop-up {
        display: inline-block;
      }
    }
  }

  .c-nav__list {
    .editMode {
      .c-nav-dropdown {
        display: block;
        position: relative;
        width: 100%;
      }
    }
  }
}
</style>
